import React from "react";
import "./ui.css";
// import star from "../../assets/star.png";
// import { Btn } from "../../utils/utils";
import agent from "../../assets/agent-pic.png";

const EachDev = ({devData}) => {
  // const starImg = [star, star, star, star, star];
  // console.log(devData);
  

  return (
    <div className="each-agent each_dev">
      <img className="each_agent_img" src={!devData?.picture ? agent : devData?.picture} alt="agent" />
      <h3>{devData?.developerName}</h3>
      {/* <div className="hhr-img">
        <div className="hrr-img_img">
          {starImg.slice(0, devData?.ratingCount).map((item, i) => {
            return <img key={i} src={item} alt="star"/>;
          })}
        </div>
        <p>{devData?.ratingCount} ({devData?.totalRatings} Reviews)</p>
      </div> */}
      <div className="btn-location">
        {/* <Btn btnLink={"/agents"} btnClass={"home-btn"} btnText={`${devData?.propertyCount} Listings`}  /> */}
        {/* <p><Location /> {location}</p> */}
      </div>
    </div>
  );
};

export default EachDev;
